import React from "react";

const Imprint = () => {
  return (
    <main className="legal">
      <header className="legalHead">
        <h1>Matteo Rosoli</h1>
        <p className="legalLead">
          Email:{" "}
          <a className="legalLink" href="mailto:office@matteorosoli.at">
            office@matteorosoli.at
          </a>
        </p>
      </header>
      <section className="legalSection">
        <h2>Website content</h2>
        <p>
          This is a private website provided for information only. All rights
          are reserved and statutory copyright law applies. Reuse or
          reproduction of its content is not permitted.
        </p>
        <dl className="legalCredits">
          <div>
            <dt>Website by</dt>
            <dd>Matteo Rosoli</dd>
          </div>
          <div>
            <dt>Logo and artwork by</dt>
            <dd>Matteo Rosoli and Ian Memic</dd>
          </div>
          <div>
            <dt>SVG animation</dt>
            <dd>
              Generated by{" "}
              <a
                className="legalLink"
                href="https://svgartista.net"
                target="_blank"
                rel="noopener noreferrer"
              >
                SVG Artista
              </a>{" "}
              on 1/7/2025, 4:49:41 PM,{" "}
              <a
                className="legalLink"
                href="https://opensource.org/license/MIT"
                target="_blank"
                rel="noopener noreferrer"
              >
                MIT License
              </a>
            </dd>
          </div>
        </dl>
      </section>
      <section className="legalSection">
        <h2>Copyright</h2>
        <p>
          The content and works created by the site operator on these pages are
          subject to Austrian copyright law. Any reproduction, editing,
          distribution or other use beyond the limits of copyright law requires
          the written consent of the respective author or creator.
        </p>
      </section>
    </main>
  );
};

export default Imprint;
